import { render, staticRenderFns } from "./a-header-navigation-item.vue?vue&type=template&id=4d0ad57b&"
import script from "./a-header-navigation-item.vue?vue&type=script&lang=js&"
export * from "./a-header-navigation-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports